/**
 * Identifying which payment method type is selected.
 */
export const getSelectedPaymentMethod = (paymentMethodType?: string) => {
  const isGooglePay = paymentMethodType === GOOGLE_PAY;
  const isApplePay = paymentMethodType === APPLE_PAY;
  const isLink = paymentMethodType === LINK;
  const isCashApp = paymentMethodType === CASH_APP;

  return {
    isGooglePay,
    isApplePay,
    isLink,
    isCashApp,
  };
};

// ─── Constants ───────────────────────────────────────────────────────────────

const GOOGLE_PAY = 'google_pay';
const APPLE_PAY = 'apple_pay';
const LINK = 'link';
const CASH_APP = 'cashapp'; // cspell:disable-line
